import React, { useEffect, useState } from 'react';
import { Modal, Button } from '@deere/ux.uxframe-react';
import { List, ListItem, Link, CircularProgress } from '@deere/fuel-react';
import { Tooltip, IconButton } from '@deere/fuel-react';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getSurveyLevelAttachments } from '../../services/surveypart.service';
import { getSurveyPartAttachmentUrl } from '../../services/surveyHelpDoc.service';

const ModalAttachments = ({ showModal, setShowModal, surveyCode, assignmentId, token, isAuthMethodOkta }) => {
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (showModal && assignmentId) {
            setLoading(true);
            setAttachments([]);
            getSurveyLevelAttachments(assignmentId, token, isAuthMethodOkta)
                .then((res) => {
                    if (res && res.data && Array.isArray(res.data)) {
                        setAttachments(res.data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                });
        }
    }, [showModal, assignmentId]);

    const fileDownloadHandler = (e, originalFilename, s3Filename) => {
        e.preventDefault();
        getSurveyPartAttachmentUrl(surveyCode, assignmentId, s3Filename, token, isAuthMethodOkta)
            .then(async (response) => {
                if (response.status === 200) {
                    const arrayBuffer = await response.arrayBuffer();
                    const blob = new Blob([arrayBuffer], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', originalFilename);
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const fileViewHandler = (e, s3Filename) => {
        e.preventDefault();
        getSurveyPartAttachmentUrl(surveyCode, assignmentId, s3Filename, token, isAuthMethodOkta)
            .then(async (response) => {
                if (response.status === 200) {
                    const arrayBuffer = await response.arrayBuffer();
                    const blob = new Blob([arrayBuffer], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Attachments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                        <CircularProgress />
                    </div>
                ) : attachments.length > 0 ? (
                    <List>
                        {attachments.map((attachment, index) => {
                            const s3Filename = attachment.s3Location.split('/').pop();
                            return (
                                <ListItem key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span>{attachment.fileName}</span>
                                    <div>
                                        <Tooltip title="View">
                                            <IconButton size="sm" variant="secondary" onClick={(e) => fileViewHandler(e, s3Filename)}>
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Download">
                                            <IconButton size="sm" variant="secondary" onClick={(e) => fileDownloadHandler(e, attachment.fileName, s3Filename)}>
                                                <DownloadIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </ListItem>
                            );
                        })}
                    </List>
                ) : (
                    <p>No attachments found.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAttachments;
